export default "__VITE_PUBLIC_ASSET__42fd2828__"